/** Falls back to `previous` rather than blanking: the tapped link is briefly null mid-restyle. */
function resolveEdgeToHighlight(selectedEdges, tappedId, previous) {
  if (!selectedEdges || selectedEdges.length === 0) {
    return previous;
  }

  if (tappedId) {
    var tapped = selectedEdges.filter(function(edge) {
      return edge.id() === tappedId;
    });
    if (tapped.length > 0) {
      return tapped[0];
    }
  }

  if (selectedEdges.length === 1) {
    return selectedEdges[0];
  }

  return previous;
}

/**
 * Anchors belong to the one selected link, so the answer is always readable off
 * the live selection. It used to be tracked in a counter that `select`/`unselect`
 * incremented and decremented, and any missed increment left the counter stuck
 * away from 1, which suppressed the handles for the rest of the session.
 */
function highlightTargetOf(selectedEdges) {
  if (!selectedEdges || selectedEdges.length !== 1) {
    return undefined;
  }
  return selectedEdges[0];
}

module.exports = {
  resolveEdgeToHighlight: resolveEdgeToHighlight,
  highlightTargetOf: highlightTargetOf
};
